var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99987 10.4839C7.91098 10.4839 7.82498 10.4672 7.74187 10.4339C7.65831 10.4005 7.58876 10.3561 7.5332 10.3005L4.46654 7.23385C4.34431 7.11163 4.2832 6.95608 4.2832 6.76719C4.2832 6.5783 4.34431 6.42274 4.46654 6.30052C4.58876 6.1783 4.74431 6.11719 4.9332 6.11719C5.12209 6.11719 5.27765 6.1783 5.39987 6.30052L7.99987 8.90052L10.5999 6.30052C10.7221 6.1783 10.8776 6.11719 11.0665 6.11719C11.2554 6.11719 11.411 6.1783 11.5332 6.30052C11.6554 6.42274 11.7165 6.5783 11.7165 6.76719C11.7165 6.95608 11.6554 7.11163 11.5332 7.23385L8.46654 10.3005C8.39987 10.3672 8.32765 10.4143 8.24987 10.4419C8.17209 10.4699 8.08876 10.4839 7.99987 10.4839Z",
    fill: "#7477B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/arrow-down-icon.89fdbc41.svg";
export { ForwardRef as ReactComponent };